export default function Marquee() {
  const items = ["Watson Group", "Central Valley", "Real Estate"];
  const line = [...items, ...items, ...items, ...items];
  return (
    <section data-testid="marquee" className="relative bg-[#0A0A0A] border-y border-white/5 py-10 overflow-hidden">
      <div className="marquee-track font-serif text-6xl md:text-8xl leading-none text-white/85">
        {line.map((t, i) => (
          <span key={i} className="inline-flex items-center gap-16">
            <span className={i % 2 ? "italic text-[#CBBFAE]/85" : ""}>{t}</span>
            <span className="text-[#CBBFAE] text-2xl">✦</span>
          </span>
        ))}
      </div>
    </section>
  );
}
